module.exports = __webpack_public_path__ + "static/media/Template_35.39471b01.png";